import React from 'react';
import { useSelector } from 'react-redux';

import { userCanAccessGlobalPrivileges } from '../../../utils/user';
import { useStatsig } from '../../hooks/useStatsig';
import FindAccommodationsLegacy from './FindAccommodationsLegacy';
import { HpEventCtaVariants } from './constants';
import ControlVariant from './variants/ControlVariant';
import HpDualVariant from './variants/HpDualVariant';
import PowerDualVariant from './variants/PowerDualVariant';

const variantMap = {
    [HpEventCtaVariants.CONTROL]: ControlVariant,
    [HpEventCtaVariants.HP_DUAL]: HpDualVariant,
    [HpEventCtaVariants.POWER_DUAL]: PowerDualVariant,
};

const isEligibleForExperiment = (user) => {
    if (!user) {
        return false;
    }
    if (user.hasPastDueSubscription) {
        return false;
    }
    if (userCanAccessGlobalPrivileges(user)) {
        return false;
    }
    return true;
};

const FindAccommodations = ({ surface, event }) => {
    const user = useSelector(({ auth }) => auth?.user);
    const { getExperiment, experiments } = useStatsig();

    // Logged-out users can't be reliably bucketed into the HP_EVENT_CTA
    // experiment, so they always see the winning HpDual variant. ENG-2584 will
    // make HpDual the permanent variant for all eligible users.
    if (!user) {
        return <HpDualVariant surface={surface} event={event} />;
    }

    if (!isEligibleForExperiment(user)) {
        return <FindAccommodationsLegacy surface={surface} event={event} />;
    }

    const experiment = getExperiment(experiments.HP_EVENT_CTA);
    const variant = experiment.get('ui_variant', HpEventCtaVariants.CONTROL);
    const VariantComponent = variantMap[variant] || ControlVariant;

    return <VariantComponent surface={surface} event={event} />;
};

export default FindAccommodations;
